import { render, staticRenderFns } from "./grid-tem.vue?vue&type=template&id=5a6027a6&scoped=true"
import script from "./grid-tem.vue?vue&type=script&lang=js"
export * from "./grid-tem.vue?vue&type=script&lang=js"
import style0 from "./grid-tem.vue?vue&type=style&index=0&id=5a6027a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6027a6",
  null
  
)

export default component.exports